@let campTypeValue = campType();
@let categoriesValue = categoriesToDisplay();

<div class="mt-4">
    <div class="size-20 header">
        {{ campTypeValue.name }}
    </div>

    @for (parentCategory of categoriesValue; track parentCategory.id) {
        <div class="mt-2">
            <app-camp-category-section
                [name]="parentCategory.name"
                [campCategoryId]="parentCategory.id"
                [subcategories]="parentCategory.campSubcategories"
                [isParentCategory]="true"
                [imgUrl]="parentCategory.photoUrl()"
                [parentImgBase64]="null"
                [photoFromParentCategory]="false"
            ></app-camp-category-section>
        </div>
    }
</div>
